import React from 'react'

import { slugService } from '../../config/slugResolution'
import fetchQueryWrapper from '../../core/fetchQueryWrapper'
import removeCircular from '../../data/transformers/removeCircular'
import { article, markdown, structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import storyStyles from '../../styles/global/story_styles.js'
import Metadata from '../Metadata'
import UnresetCSS from '../UnresetCSS'
import StoryDetails from './StoryDetails'

import resolveResponse from 'contentful-resolve-response'
import Head from 'next/head'

export const storyParams = ({ slug = false, id = false }) => ({
  content_type: 'story',
  include: 3,
  ...(id && { 'sys.id[in]': id }),
  ...(slug && { 'fields.slug[in]': slug })
})

export const getStoryBySlug = async slug => {
  const response = await fetchQueryWrapper(storyParams({ slug }), resolveResponse)
  const story = response[0]

  if (!story) {
    const slugLookup = await slugService(slug)

    if (slugLookup.status !== 200 || !slugLookup.data?.[0]?.entryId) {
      return false
    }

    const storyById = await getStoryById(slugLookup.data?.[0]?.entryId)
    if (storyById) {
      return removeCircular({ ...storyById[0]?.fields, id: storyById[0]?.sys?.id })
    }
  }

  return removeCircular({ ...story?.fields, id: story?.sys?.id })
}

const getStoryById = id => fetchQueryWrapper(storyParams({ id }), resolveResponse)

export const Story = ({ data, region, path }) => {
  const collection = {
    id: data?.categories?.[0]?.sys?.id,
    region: region.contentfulId
  }
  const rawTitle = data?.title
  const hasPrefix = /^news\s*12\s*\|\s*/i.test(rawTitle ?? '')

  const title = rawTitle ? (hasPrefix ? rawTitle : `News 12 | ${region.longName} | ${rawTitle}`) : 'News 12'
  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel='amphtml' href={`https://${region.name}.news12.com/amp${path}`} />
        <link rel='canonical' href={`https://${region.name}.news12.com${path}`} />
        <meta property='category' content={`${data?.categories?.join(', ')}`} />
      </Head>
      <Metadata
        metadata={{
          ...{ title: data?.title, description: data?.description, thumbnail: data?.thumbnail }
        }}
      />
      <StoryDetails story={data} collection={collection} />
      <style jsx global>
        {article}
      </style>
      <style jsx global>
        {structure}
      </style>
      <UnresetCSS />
      <BaseCSS />
      <style jsx global>
        {markdown}
      </style>
      <style jsx global>
        {storyStyles}
      </style>
    </>
  )
}

export default Story
